import moment from 'moment-timezone'
import numeral from 'numeral'

export function useFormatFunc() {
  /**
   * 
   * @param srcDate 日付の文字列
   * @returns 
   */
  function parseDate(srcDate?: string): Date | undefined {
    if (!srcDate) {
      return undefined
    }
    return moment(srcDate).tz('Asia/Tokyo').toDate()
  }

  /**
   * 指定した日付をフォーマットして返します
   * @param srcDate 日付の文字列
   * @param formatStr フォーマット文字列
   * @returns
   */
  function formatDate(srcDate?: Date | string, formatStr?:string): string {
    if (!srcDate) {
      return ''
    }

    let format = formatStr
    if (!formatStr) {
      format = 'YYYY.MM.DD'
    }
    return moment(srcDate).tz('Asia/Tokyo').format(format)
  }

  function formatISODate(srcDate?: Date | string): string {
    if (!srcDate) {
      return ''
    }
    return moment(srcDate).tz('Asia/Tokyo').toISOString()
  }

  /**
   * 指定した数値をフォーマットして返します
   * @param srcVal 数値
   * @param formatStr フォーマット文字列
   * @returns
   */
  function formatNum(srcVal?: number, formatStr?:string): string {
    if (srcVal === undefined) {
      return ''
    }

    let format = formatStr
    if (!formatStr) {
      format = '0,0'
    }
    return numeral(srcVal).format(format)
  }

  /**
   * 指定した数値をフォーマットして返します
   * @param srcVal 数値
   * @param formatStr フォーマット文字列
   * @returns
   */
  function formatNumUnitPrice(srcVal?: number, formatStr?:string): string {
    if (srcVal === undefined) {
      return ''
    }

    let format = formatStr
    if (!formatStr) {
      format = '0,0.00'
    }
    return numeral(srcVal).format(format)
  }

  function formatNumStaffNo(srcVal?: number): string {
    if (srcVal === undefined) {
      return ''
    }

    return String(srcVal+1).padStart(2, '0')
  }

  return {
    parseDate,
    formatDate,
    formatISODate,
    formatNum,
    formatNumUnitPrice,
    formatNumStaffNo,
  }
}
